module.exports = __webpack_public_path__ + "files/6a0b63550b7392edf772d03ca436bfcc.png";